import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Stepper, Step } from "react-form-stepper";
import logo from '../Img/ProMed_Logo.png';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ResetForm = () => {
  const [step, setStep] = useState(0);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isResettingPassword, setIsResettingPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    otp: ["", "", "", "", "", ""],
    password: "",
    confirmPassword: ""
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [timer, setTimer] = useState(59);
  const [resendAvailable, setResendAvailable] = useState(false);
  const otpRefs = useRef([]);
  const firstFieldRef = useRef(null);
  const navigate = useNavigate();

  const handleResetPassword = async () => {
    if (!validateStep()) return;

    setIsResettingPassword(true);
    try {
      const response = await fetch("https://backend.impactjournal.co.in/register/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: formData.email,
          otp: formData.otp.join(""),
          password: formData.password
        })
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Password reset successful!");
        setFormData(prev => ({
          ...prev,
          password: "",
          confirmPassword: ""
        }));
        setTimeout(() => navigate("/login-impact"), 2000);
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error("Password reset error", err);
      toast.error("Something went wrong.");
    } finally {
      setIsResettingPassword(false);
    }
  };

  useEffect(() => {
    if (firstFieldRef.current) firstFieldRef.current.focus();
  }, [step]);

  useEffect(() => {
    if (step === 1 && timer > 0) {
      const interval = setInterval(() => setTimer(prev => prev - 1), 1000);
      return () => clearInterval(interval);
    } else if (timer === 0) {
      setResendAvailable(true);
    }
  }, [step, timer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleOTPChange = (index, value) => {
    const otp = [...formData.otp];
    otp[index] = value.slice(0, 1);
    setFormData({ ...formData, otp });
    if (value && index < otpRefs.current.length - 1) {
      otpRefs.current[index + 1].focus();
    }
  };

  const validateStep = () => {
    const newErrors = {};
    if (step === 0) {
      if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        newErrors.email = "Valid email is required";
      }
    } else if (step === 1) {
      if (formData.otp.some(d => d === "")) newErrors.otp = "All OTP fields are required";
    } else if (step === 2) {
      if (!formData.password || formData.password.length < 6) newErrors.password = "Password must be at least 6 characters";
      if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = "Passwords do not match";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const nextStep = () => {
    if (validateStep()) setStep(prev => prev + 1);
  };

  const prevStep = () => setStep(prev => prev - 1);

  const handleResend = () => {
    setTimer(59);
    setResendAvailable(false);
    console.log("OTP resent to:", formData.email);
  };

  const renderError = (field) => errors[field] && (
    <div className="form-register-error-impact">{errors[field]}</div>
  );

  const handleEmailSubmit = async () => {
    if (validateStep()) {
      setIsSendingOtp(true);
      try {
        const res = await fetch("https://backend.impactjournal.co.in/register/request-reset-otp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: formData.email })
        });

        const result = await res.json();
        if (res.ok) {
          setStep(1);
          setTimer(59);
          setResendAvailable(false);
          toast.success("OTP sent to your registered email");
        } else {
          toast.error(result.message);
        }
      } catch (err) {
        console.error("OTP request failed", err);
        toast.error("Something went wrong.");
      } finally {
        setIsSendingOtp(false);
      }
    }
  };

  return (
    <>
      {/* <ToastContainer position="top-center" autoClose={3000} /> */}
      <div className="register-main-pm">
        <div className="register-section-pm">
          <div className="register-container-left-pm">
            <img src={logo} alt="logo" />
            <h2>RESET YOUR PASSWORD</h2>
            <p>Enter your email and follow the steps to reset your account password securely.</p>
          </div>

          <div className="form-register-wrapper-impact">
            <Stepper activeStep={step} className="form-register-stepper-impact">
              <Step label="Email" />
              <Step label="OTP" />
              <Step label="New Password" />
            </Stepper>

            {step === 0 && (
              <div className="form-register-step-impact">
                <h2>Reset your password</h2>
                <div className="form-register-input-group-impact">
                  <input
                    ref={firstFieldRef}
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-register-input-impact"
                  />
                  {renderError("email")}
                </div>

                <div className="form-register-navigation-impact">

                  <button
                    onClick={() => {
                      if (step === 0) {
                        navigate("/login-impact");
                      } else {
                        prevStep();
                      }
                    }}
                    className="form-register-btn-impact form-register-btn-back-impact"
                  >
                    Back
                  </button>



                  <button onClick={handleEmailSubmit} className="form-register-btn-impact form-register-btn-next-impact">
                    Send OTP
                  </button>


                </div>
              </div>
            )}

            {step === 1 && (
              <div className="form-register-step-impact">
                <p className="otp-instruction">OTP sent to <br /><strong>{formData.email}</strong></p>
                <div className="form-register-otp-wrapper-impact">
                  {formData.otp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      value={digit}
                      onChange={(e) => handleOTPChange(index, e.target.value)}
                      className="form-register-otp-input-impact"
                      maxLength={1}
                      ref={(el) => otpRefs.current[index] = el}
                      onKeyDown={(e) => {
                        if (e.key === 'Backspace' && !digit && index > 0) {
                          otpRefs.current[index - 1].focus();
                        }
                      }}
                    />
                  ))}
                </div>
                {renderError("otp")}
                <div className="otp-resend-section">
                  {resendAvailable ? (
                    <button onClick={handleResend} className="form-resend-code-btn">Resend Code?</button>
                  ) : (
                    <p className="otp-timer">Resend available in 0:{timer < 10 ? `0${timer}` : timer}</p>
                  )}
                </div>

              </div>
            )}

            {step === 2 && (
              <div className="form-register-step-impact">
                <div className="form-register-input-group-impact">
                  <div className="form-register-password-wrapper-impact">
                    <input
                      name="password"
                      type={showPassword ? "text" : "password"}
                      placeholder="New Password"
                      value={formData.password}
                      onChange={handleChange}
                      className="form-register-input-impact"
                    />
                    <i
                      className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} form-register-eye-icon-impact`}
                      onClick={() => setShowPassword(!showPassword)}
                    />
                  </div>
                  {renderError("password")}
                </div>

                <div className="form-register-input-group-impact">
                  <div className="form-register-password-wrapper-impact">
                    <input
                      name="confirmPassword"
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirm New Password"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      className="form-register-input-impact"
                    />
                    <i
                      className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"} form-register-eye-icon-impact`}
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    />
                  </div>
                  {renderError("confirmPassword")}
                </div>
              </div>
            )}

            <div className="form-register-navigation-impact">
              {step > 0 && (
                <button onClick={prevStep} className="form-register-btn-impact form-register-btn-back-impact">Back</button>
              )}
              {step < 2 ? (
                <button onClick={nextStep} className="form-register-btn-impact form-register-btn-next-impact">
                  Next
                </button>
              ) : (
                <button
                  onClick={handleResetPassword}
                  className="form-register-btn-impact form-register-btn-submit-impact"
                >
                  Reset Password
                </button>

              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetForm;
